interface CollapsibleText {
    index: number
    container: typeof $<HTMLElement>
    element: typeof $<HTMLElement>
    toggle: typeof $<HTMLElement>
}

export class Seo {
    collapsibleTexts: CollapsibleText[]

    constructor() {
        this.collapsibleTexts = []
        const collapsibles = $(".collapsible-text")
        let currentCollapsible: typeof $<HTMLElement>
        let index = 0
        const indexMax = collapsibles.length

        $(document).on("click", "a.label[data-for]", this.clickForLinkedElement.bind(this))

        for (; index < indexMax; index++) {
            currentCollapsible = $(collapsibles[index])

            this.collapsibleTexts.push({
                index: index,
                container: currentCollapsible.data("id", index).prop("id", `collapsible-${index}`),
                element: this.prepareCollapsible(currentCollapsible),
                toggle: this.createCollapsibleTextToggleElement(currentCollapsible),
            })
        }
    }

    clickForLinkedElement(clickEvent: typeof $.ClickEvent) {
        const clickElement = $(clickEvent.currentTarget)

        if (!clickElement.length || "" === clickElement.data("for")) {
            return
        }

        const targetElement = $(`#${clickElement.data("for")}`)

        if (!targetElement.length) {
            return
        }

        clickEvent.preventDefault()
        targetElement.click()
    }

    createCollapsibleTextToggleElement(collapsible: typeof $<HTMLElement>): typeof $<HTMLElement> {
        const toggleElement = $("<a />")
        const collapseId = `#${collapsible.prop("id")}-content`

        toggleElement
            .addClass("collapsible-text-toggle")
            .prop("href", "")
            .click((clickEvent: MouseEvent) => {
                clickEvent.preventDefault()
                clickEvent.stopPropagation()

                $(collapseId).collapse("toggle")
                // this.blur();
                // TODO huh?
            })

        collapsible.append(toggleElement)

        return toggleElement
    }

    prepareCollapsible(collapsible: typeof $<HTMLElement>): typeof $<HTMLElement> {
        const collapsibleContent = $("<div />")

        collapsibleContent
            .html(collapsible.html())
            .addClass("collapse")
            .prop("id", `${collapsible.prop("id")}-content`)

        collapsible.empty().append(collapsibleContent).addClass("ready")

        return collapsibleContent
    }
}

new Seo()
